import { TUserProfileTabs } from "@components/user-profile";
import UserTab from "./components/tab";
import styles from "./profile-tabs.module.scss";
import { userProfileTabs } from "@components/user-profile";

export default function ProfileTabs({
  currentTab,
  changeTab,
}: {
  currentTab: TUserProfileTabs;
  // eslint-disable-next-line no-unused-vars
  changeTab: (tab: TUserProfileTabs) => void;
}): JSX.Element {
  return (
    <div className={styles.tabs}>
      {userProfileTabs.map((tab, index) => (
        <UserTab
          title={tab.title}
          tabIndex={index}
          currrentTab={currentTab}
          selectTab={() => changeTab(index as TUserProfileTabs)}
          key={`${tab.title}-${index}`}
        />
      ))}
    </div>
  );
}
